import { ApiService } from '../services/api_service';
import { IDs } from '../helpers/IDs';
import { lazyInject } from '../services/inversify';
import * as Moment from 'moment';
import * as React from 'react';
import { validateFieldUniversal } from '../bereiche/dateneingabe/functions/validateField';
import { WActionButton } from '../core/elements/WActionButton';
import { WFormsTableWrapper } from '../core/table/WFormsTableWrapper';
import { WSpinner } from '../core/elements/spinner/WSpinner';

export interface FaktorenFeedbackProps {
    data: any;
    isAdmin?: boolean;
}

export interface FaktorenFeedbackState {
    data: any[];
    filterMandant: boolean;
    isLoading: boolean;
}

export class FaktorenFeedback extends React.Component<FaktorenFeedbackProps, FaktorenFeedbackState> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: [],
            filterMandant: false,
            isLoading: false
        };
        this.customFormatter = this.customFormatter.bind(this);
        this.customFormConfigFunc = this.customFormConfigFunc.bind(this);
        this.onAfterAction = this.onAfterAction.bind(this);
        this.onFormSave = this.onFormSave.bind(this);
        this.onSaveDone = this.onSaveDone.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;

    private formatFloat: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 9, useGrouping: true });
    private mandant: string;

    componentDidMount(): void {
        this.mandant = this.apiService.getMandantKey();
        this.loadData();
    }

    customFormatter(field: string, value: any, data: any, row: any): any {
        if (field === 'faktor') {
            return typeof value === 'number' ? this.formatFloat.format(value) : value;
        }

        return value;
    }

    customFormConfigFunc(formConfig: any, formData: any): void {
        if (this.props.isAdmin) {
            return;
        }
        const index: number = ((formConfig || {}).items || []).findIndex((item: any) => item.key === 'bemerkung_admin');

        if (index >= 0) {
            formConfig.items[index].hidden = !((formData || {}).values || {}).tid;
        }
    }

    getData(): any[] {
        return this.state.filterMandant
            ? (this.state.data || []).filter((item: any) => item.mandant === this.mandant)
            : this.state.data;
    }

    getExternalHeaderElements(): JSX.Element[] {
        const elements: JSX.Element[] = [];
        const style: React.CSSProperties = {
            cursor: 'pointer', display: 'flex', alignItems: 'center', height: 28, marginTop: 2, fontSize: 12, padding: '0 3px',
            backgroundColor: 'rgb(188, 202, 227)', marginRight: 2
        };
        elements.push(
            <WActionButton
                label='Erneut laden'
                action='reload'
                key='action_reload'
                onAction={() => this.loadData()}
                tooltip='Neu laden'
                place='bottom'
            />
        );

        if (!this.props.isAdmin) {
            elements.push(
                <label style={style}>
                    <input
                        type='checkbox'
                        checked={this.state.filterMandant}
                        onChange={(event: any) => this.setState({ filterMandant: event.target.checked })}
                    />
                    Nur meine Anfragen
                </label>
            );
        }

        return elements;
    }

    loadData(): void {
        this.setState({ isLoading: true },
            () => this.apiService.call(
                'getCo2Faktoren',
                { mandant_key: this.mandant },
                (json: string, success: boolean) => {
                    if (success) {
                        let obj: any[];

                        try {
                            obj = JSON.parse(json || '[]');
                        } catch (e) {
                            console.error(e, json);
                        }
                        const data: any[] = obj.map((item: any) => (
                            { ...item, ...(!this.props.isAdmin && !item.mandant && { _noActions: true }) })
                        );
                        this.setState({ data, isLoading: false });
                    }
                },
                IDs.MOD_ETOOL
            )
        );
    }

    onAfterAction(action: string, data: any): void {
        if (action === 'saveDone' || action === 'delDone') {
            this.loadData();
        }
    }

    onFormSave(data: any, callback: () => void): void {
        data = data || {};

        if (!this.props.isAdmin && typeof data.datum !== 'undefined') {
            data.datum = Moment().unix();
        }
        callback();
    }

    onSaveDone(entityName: string, values: any, bundle: any, saveTid: number): void {
        // this.sendMail({ tid: values.tid || (saveTid > 0 ? saveTid : null) });
    }

    render(): JSX.Element {
        const { isAdmin } = this.props;

        return <>
            <WFormsTableWrapper
                entity={IDs.ENT_CO2_FAKTOREN}
                module={IDs.MOD_ETOOL}
                data={this.getData()}
                globalData={this.props.data}
                actions={['add', 'edit', 'delete']}
                addLabel='Faktor erfassen'
                externalHeaderElements={this.getExternalHeaderElements()}
                formPreset={{ status: 'offen' }}
                customFormConfig={{
                    bemerkung_admin: { readonly: !isAdmin },
                    status: { hidden: !isAdmin }
                }}
                customFormConfigFunc={this.customFormConfigFunc}
                customFormatter={this.customFormatter}
                customClass='Custom-ETA'
                formLayout='flowV2'
                callBeforeOnFormSave={this.onFormSave}
                validateField={this.validateField}
                onSaveDone={this.onSaveDone}
                onAfterAction={this.onAfterAction}
                tablePageSize={10}
            />
            {this.state.isLoading && <WSpinner />}
        </>;
    }

    sendMail(data: any): void {
        this.apiService.call(
            'sendMailCo2Faktoren',
            { data },
            (json: string, success: boolean) => console.info('sendMail', json, success),
            IDs.MOD_ETOOL
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        return validateFieldUniversal(IDs.ENT_CO2_FAKTOREN, key, value, data, onValueChange);
    }
}
